export default __webpack_public_path__ + "650c28c35e411b5e03155041d170dce2.svg";